<template>
  <div class="layout-page">
    <div>
      <el-menu
        @select="select"
        :default-active="active"
        class="el-menu-vertical"
        :collapse-transition="false"
      >
        <div class="back-container" @click="backClick">
          <div class="back-icon"></div>
          <div class="back-text">Schedule</div>
        </div>
        <el-menu-item index="account">
          <span slot="title">Account</span>
        </el-menu-item>
        <el-menu-item index="default-time">
          <span slot="title">Default Post Time</span>
        </el-menu-item>
        <el-menu-item index="default-caption-comment">
          <span slot="title"
            >Default Caption or<br />
            Comment</span
          >
        </el-menu-item>
        <el-menu-item index="manager-caption-comment">
          <span slot="title"
            >Manage Caption or<br />
            Comment</span
          >
        </el-menu-item>
        <!-- <el-menu-item index="manager-search-repost">
          <span slot="title">Search & Repost</span>
        </el-menu-item> -->
        <el-menu-item index="notifications">
          <span slot="title">Notifications</span>
        </el-menu-item>
        <li
          class="el-menu-item"
          @click="select('logout')"
          style="padding-left: 20px"
        >
          <span>Logout</span>
        </li>
        <!--<el-menu-item index="logout">-->
        <!--<span slot="title">Logout</span>-->
        <!--</el-menu-item>-->
      </el-menu>
    </div>
    <div class="main-container">
      <router-view />
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "../../assets/style/theme";

.layout-page {
  height: 100vh;
  max-width: 100vw;
  display: flex;

  .main-container {
    flex: 1;
    min-height: 1px;
    min-width: 300px;
  }

  .back-container {
    height: 80px;
    text-align: left;
    border-right: 3px solid transparent;
    padding-left: 20px;
    font-size: 14px;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 40px;
    line-height: 1;

    &:hover,
    &:active {
      opacity: 0.7;
    }

    .back-icon {
      height: 25px;
      width: 25px;
      background: url("../../../public/images/common/Calender_icon_Back@3x.png");
      background-size: contain;
    }

    .back-text {
      position: relative;
      top: 2px;
    }
  }
}
</style>
<style>
.el-menu-vertical {
  min-height: 100vh;
}
</style>

<script>
import { mapGetters } from "vuex";
import {
  ACCOUNT_BACK,
  CURRENT_PUBLISHER_SIMPLE,
} from "../../store/mutation-types";
import { logout, updateUserInfo } from "../../service/user";

export default {
  name: "LayoutPage",
  computed: {
    ...mapGetters({
      accountBack: ACCOUNT_BACK,
      currentPublisher: CURRENT_PUBLISHER_SIMPLE,
    }),
    active() {
      return this.$route.path.split("/settings/")[1];
    },
  },
  methods: {
    async select(router) {
      if (router === "logout") {
        await this.$confirm.show({
          text: `Do you want to logout your apphi account?`,
        });
        logout();
      } else {
        this.$router.push({ path: router });
      }
    },
    /**
     * 返回按钮点击
     */
    async backClick() {
      this.$router.push({ name: "SchedulePage" });
      await updateUserInfo({});
    },
  },
};
</script>
